// shadcn/ui 스타일 유틸리티 함수
// clsx와 tailwind-merge를 조합하여 조건부 클래스명 처리

import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * 클래스명을 조건부로 결합하고 Tailwind 충돌을 해결하는 유틸리티 함수
 * @param inputs - 클래스명 배열 또는 조건부 객체
 * @returns 병합된 클래스명 문자열
 */
export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}
